import * as React from 'react';
import Form from 'react-bootstrap/Form';
import { DateRangePicker } from 'react-dates';
import Col from 'react-bootstrap/Col';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import moment from 'moment';
import ReactDOM from 'react-dom';
import {
  getFarsData,
  onReportToRemove,
  onDataToEdit,
  sendToNhtsa,
  deleteFars,
  getFormIoFormId,
} from './redux-objects/actions';
import { Redirect } from 'react-router-dom';
import './assets/FarsEditorStyle.scss';
import './FarsInvestigatorQueue';
import DataTable from '../../DataTable';
import FormIO from '../../FormIO/presentation/FormWithValidations';
import {
  IFARSData,
  IFARSPersonData,
  IFarsQueueItem,
} from '../../../common/sharedTypes';
import FarsInvestigatorQueue from './FarsInvestigatorQueue';
import * as urls from '../../shared/urls';
import { toast } from 'react-toastify';
import './assets/FarsStyle.scss';
import CheckBox from '../../Elements/CheckBox';

export interface IFarsDataActionProps {
  getFarsData?: (url: string, dateFilter: any, showSent: boolean) => void;
  onDataToEdit?: (url: string, data: any) => Promise<void>;
  onDataToDelete?: (url: string, data: any) => void;
  sendToNhtsa?: (url: string, id: number) => Promise<void>;
  deleteFars?: (url: string, id: number) => Promise<void>;
  getFormIoFormId: () => void;
}

interface IFarsDataStateProps {
  farsData: IFarsQueueItem[];
  farsSearchData: any[];
  dataToEdit: any[];
  farsDataToAdd: any[];
  appUrl: string;
  formIOUrl: string;
  farsFormIoFormId: string;
}

export interface IFarsDataProps
  extends IFarsDataActionProps,
  IFARSData,
  IFARSPersonData,
  IFarsDataStateProps { }

class ManageFARs extends React.Component<IFarsDataProps, any> {
  private farsForm: any;

  public constructor(props: IFarsDataProps) {
    super(props);
    this.state = {
      startDate: moment('1/2/2016', 'MM/dd/YYYY'),
      endDate: moment(new Date(), 'MM/dd/YYYY'),
      focusedInput: null,
      redirect: false,
      show: false,
      currentRow: null,
      renamedKeysCurrentRow: null,
      form: {},
      formErrors: null,
      showSent: false
    };
  }

  doGetFarsData = () => {
    this.props.getFarsData(this.props.appUrl + 'farsReport/FarsReportData', {
      StartDate: moment(this.state.startDate).format('L'),
      EndDate: moment(this.state.endDate).format('L')
    },
      this.state.showSent);
  }

  componentDidMount(): void {
    this.doGetFarsData();

    if (!this.props.farsFormIoFormId)
      this.props.getFormIoFormId();
  }

  setFormErrors(errors: Array<any>) {
    this.setState({
      formErrors: errors
    });
  }

  handleChange(changed: CustomEvent) {
    //console.log(changed);
  }

  handleShow = () => {
    this.setState({ show: true });
  };

  handleClose = () => {
    this.doGetFarsData();
    this.setState({ show: false });
  };

  handleDatesChanged(startDate, endDate) {
    if (startDate && endDate) {
      this.setState({ startDate, endDate }, () => {
        this.doGetFarsData();
      });
    }
  }

  toPascal = (s) => {
    return s.charAt(0).toUpperCase() + s.slice(1);
  };

  isObject = (obj) => {
    return (
      obj === Object(obj) && !Array.isArray(obj) && typeof obj !== 'function'
    );
  };

  keysToPascal = (obj) => {
    if (this.isObject(obj)) {
      const n = {};
      Object.keys(obj).forEach((k) => {
        n[this.toPascal(k)] = this.keysToPascal(obj[k]);
      });
      return n;
    } else if (Array.isArray(obj)) {
      return obj.map((i) => {
        return this.keysToPascal(i);
      });
    }
    return obj;
  };

  handleNew() {
    this.handleShow();
    const renamedKeysCurrentRow = null;
    this.setState({ renamedKeysCurrentRow });
  }

  handleEdit(rowData: IFarsQueueItem) {
    this.handleShow();
    const renamedKeysCurrentRow = this.keysToPascal(rowData.farsJson);
    this.setState({ renamedKeysCurrentRow });
  }

  handleSave(event: any) {
    let { data } = event.form.formio;
    // if (data.NonMotorist.DeathCertificate == '') {
    //   return data.NonMotorist == [];
    // }
    //console.log('handle save data: ', JSON.stringify(data));
    this.props
      .onDataToEdit(this.props.appUrl + 'farsReport/UpdateFarsReport', data)
      .then((result: any) => {
        if (result.ok) {
          toast.success('Saved');
        } else {
          toast.error('Error saving');
        }
      });
    //this.handleClose();
    this.setState({ show: false });
  }

  renameKeys(obj, newKeys) {
    const keyValues = Object.keys(obj).map((key) => {
      if (key == 'occupant') {
        return { occupant: obj.isDriver ? 'driver' : 'passenger' };
      }

      const newKey = newKeys[key] || key;
      return { [newKey]: obj[key] };
    });
    return Object.assign({}, ...keyValues);
  }

  handleDelete(rowData: IFarsQueueItem) {
    this.props
      .sendToNhtsa(urls.DELETE_FARS_REPORT, rowData.farsCrashData.id)
      .then((x) => {
        console.log('response', x);
        toast.success('Deleted');
      });
  }

  handleSendNhtsa(rowData: IFarsQueueItem) {
    this.props
      .sendToNhtsa(urls.SEND_TO_NHTSA, rowData.farsCrashData.id)
      .then((x: any) => {
        console.log('response', x);
        if (x == "Unable to send") {
          toast.error(x);
        } else {
          toast.success('Extract Sent to NHTSA');
        }
      });
  }

  checkStatus(cellData) {
    const currentRow = this.props.farsData.find(
      (farsData) => farsData.farsCrashData.id == cellData
    );
    if (currentRow.farsCrashData.isActive == true) {
      return 'Delete';
    } else {
      return 'Delete';
    }
  }

  handleShowSent(show: any) {
    this.setState({ showSent: show }, () => {
      this.doGetFarsData();
    }
    );
  }

  public render() {
    if (this.state.redirect) {
      return <Redirect push to='/ManageFARs' />;
    }

    const columnDefs = [
      {
        targets: 0,
        createdCell: (td, cellData, rowData, row, col) =>
          ReactDOM.render(
            <div className='row'>
              <Button
                variant='outline-primary'
                className='fars-btn'
                size='sm'
                data-id={cellData}
                onClick={() => this.handleEdit(rowData)}
              >
                Edit
              </Button>
              <Button
                variant='outline-danger'
                className='fars-btn'
                size='sm'
                data-id={cellData}
                onClick={() => this.handleDelete(rowData)}
              >
                {this.checkStatus(cellData)}
              </Button>
              <Button
                variant='outline-success'
                className='fars-btn'
                size='sm'
                data-id={cellData}
                disabled={rowData.farsCrashData.crashKey == null || rowData.farsCrashData.crashKey == ""}
                onClick={() => this.handleSendNhtsa(rowData)}
              >
                Send to NHTSA
              </Button>
            </div>,
            td
          ),
      },
      {
        targets: 3,
        type: 'date',
        render: function (data) {
          return moment(data).format('lll');
        },
      },
      {
        targets: 7,
        createdCell: (td, cellData, data, row, col) =>
          ReactDOM.render(
            <ul>
              {(data.farsCrashData.farsCrashTypes &&
                data.farsCrashData.farsCrashTypes.length > 0 &&
                data.farsCrashData.farsCrashTypes.map((x) => {
                  return (
                    <li key={x.farsRefCrashType.code}>
                      {x.farsRefCrashType.description}
                    </li>
                  );
                })) ||
                ''}
            </ul>,
            td
          ),
      },
    ];

    const columns = [
      {
        title: 'Available Actions',
        data: 'farsCrashData.id',
      },
      {
        title: 'Fars Case Number',
        data: 'farsCrashData.caseNumber',
      },
      {
        title: 'Crash Key',
        data: 'farsCrashData.crashKey',
      },
      {
        title: 'Date of Crash',
        data: 'farsCrashData.dateOfCrash',
      },
      {
        title: 'Fatalities',
        data: 'farsCrashData.fatalities',
      },

      {
        title: 'Crash Location',
        mData: function (data: IFarsQueueItem, type, dataToSet) {
          return (
            (data.farsCrashData.farsRefCrashLocation &&
              data.farsCrashData.farsRefCrashLocation.description) ||
            ''
          );
        },
      },

      {
        title: 'Manner Of Impact',
        mData: function (data: IFarsQueueItem, type, dataToSet) {
          return (
            (data.farsCrashData.farsRefCollisionType &&
              data.farsCrashData.farsRefCollisionType.description) ||
            ''
          );
        },
      },
      {
        title: 'Crash Type',
        data: 'farsCrashData',
      },
      {
        title: "Sent",
        mData: function (data: IFarsQueueItem, type, dataToSet) {
          return data.farsCrashData.isSent ? 'Yes' : 'No';
        }
      },
    ];

    const options = {
      className: 'table table-striped table-bordered',
    };

    return (
      <div className='app'>
        <FarsInvestigatorQueue />
        <hr className='line-separator' />
        <Form>
          <Form.Row>
            <Form.Group as={Col} controlId='farsQueueStartDate'>
              <Form.Label>Search by Date</Form.Label>
              <br />
              <DateRangePicker
                startDate={this.state.startDate}
                startDateId='farsQueueStartDate'
                endDate={this.state.endDate}
                endDateId='farsQueueEndDate'
                onDatesChange={({ startDate, endDate }) =>
                  this.handleDatesChanged(startDate, endDate)
                }
                focusedInput={this.state.focusedInput}
                onFocusChange={(focusedInput) =>
                  this.setState({ focusedInput })
                }
                isOutsideRange={() => false}
                small={true}
                block={false}
                minimumNights={0}
              />
            </Form.Group>
            <Form.Group as={Col} controlId='farsChkQueueSent'>
              <Form.Check
                type="checkbox"
                label=" Show Sent"
                checked={this.state.showSent}
                onChange={(e) =>
                  this.handleShowSent(e.target.checked)
                }
              />
            </Form.Group>
            <Form.Group>
              <Button onClick={(e) => this.handleNew()} variant='primary'>
                New FARS Report
              </Button>
            </Form.Group>
          </Form.Row>
        </Form>
        <h4 className='fars-datagrid-title'>Fars Search Results:</h4>
        <DataTable
          id='tblFarsData'
          data={
            Array.isArray(this.props.farsData)
              ? this.props.farsData.filter(
                (item) => item.farsCrashData.isActive == true
              )
              : []
          }
          columns={columns}
          columnDefs={columnDefs}
          {...options}
          pageLength={5}
          select={false}
        />
        <Modal
          show={this.state.show}
          onHide={this.handleClose}
          aria-labelledby='contained-modal-title-center'
          centered
          dialogClassName='modal-90w'
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit FARS Form</Modal.Title>
          </Modal.Header>
          <Modal.Body className='FarsModalBody'>
            <FormIO
              formId={this.props.farsFormIoFormId}
              onChange={(e) => this.handleChange(e)}
              data={
                this.state.renamedKeysCurrentRow
                  ? { data: { ...this.state.renamedKeysCurrentRow } }
                  : {}
              }
              ref={(farsForm: any) => (this.farsForm = farsForm)}
              setFormErrors={(errors) => this.setFormErrors(errors)}
            />
          </Modal.Body>
          <div id='container custom' className='custom-fars-container'>
            <Button
              type='button'
              className='btn-primary custom-save-button-fars-search'
              onClick={() => this.handleSave(this.farsForm)}
              value={this.farsForm}
              disabled={this.state.formErrors?.some(error => error.message.includes('Date of Crash'))}
            >
              Save Form
            </Button>
            <Button
              className='btn-secondary custom-close-button-fars-search'
              onClick={this.handleClose}
            >
              Close Form Editor
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (reduxState: any) => {
  return {
    farsData: reduxState.farsSearchData.farsData,
    farsSearchData: reduxState.farsSearchData.farsSearchData,
    farsFilterCaseNumber: reduxState.farsSearchData.farsFilterCaseNumber,
    farsDataToEdit: reduxState.farsSearchData.farsDataToEdit,
    farsDataToDelete: reduxState.farsSearchData.farsDataToDelete,
    appUrl: reduxState.Application.backendURL,
    formIOUrl: reduxState.Application.formIOUrl,
    farsFormIoFormId: reduxState.farsSearchData.farsFormIoFormId,
  };
};

const mapDispatchToProps = {
  getFarsData,
  onDataToEdit,
  onReportToRemove,
  sendToNhtsa,
  deleteFars,
  getFormIoFormId,
};

export default connect<any>(mapStateToProps, mapDispatchToProps)(ManageFARs);
